import API from 'utils/API';
import http from 'utils/http';
import withPreload from 'utils/withPreload';

export interface DeviceInitType {
    location_config?: {
        location: string; // ip获得的国家码
        location_name: string;
    };
}

const cache: {
    location?: Promise<DeviceInitType>;
} = {};

export function getLocation(key = 'location'): Required<typeof cache>['location'] {
    return (
        cache[key] ||
        (cache[key] = http
            .get<DeviceInitType>(API.OAUTH.deviceInit())
            .then(res => res.data)
            .catch(error => {
                cache[key] = undefined;

                throw error;
            }))
    );
}

/**
 * @description
 * 获取用户 ip 地址
 */
const withLocation = withPreload<'locations'>(() => getLocation(), {
    prop: 'locations'
});

export default withLocation;
